<template>
  <div>
    <b-overlay
      :show="loadingOverlay"
      rounded="sm"
    >
      <b-card no-body>
        <b-card-header class="pb-50">
          <h5>{{ $t('filtros') }}</h5>
        </b-card-header>

        <!-- Filter Section -->
        <b-card-body>
          <b-row>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="mb-2"
            >
              <label>{{ $t('spot.relatorio.labelDataIncial') }}</label>
              <flat-pickr
                v-model="dataBuscaFilter.inicio"
                class="form-control"
                :config="flatpickrConfig"
              />
            </b-col>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="mb-2"
            >
              <label>{{ $t('spot.relatorio.labelDataFinal') }}</label>
              <flat-pickr
                v-model="dataBuscaFilter.fim"
                class="form-control"
                :config="flatpickrConfig"
              />
            </b-col>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="mb-2"
            >
              <label>{{ $t('palavraChave') }}</label>
              <b-form-input
                v-model="searchQuery"
                class="form-control"
              />
            </b-col>
            <b-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="mb-2 d-flex align-items-end"
            >
              <b-button
                v-ripple.400="'rgba(59, 130, 246, 0.15)'"
                variant="primary"
                block
                class="btn-icon"
                @click.prevent="buscarFiltro"
              >
                <feather-icon
                  icon="SearchIcon"
                  class="mr-1"
                  size="16"
                />
                <span>{{ $t('spot.relatorio.pesquisarBtn') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>

        <!-- Statistics Cards -->
        <b-card-body class="border-top">
          <b-row>
            <!-- Total de Usuários -->
            <b-col
              cols="12"
              sm="6"
              lg="3"
              class="mb-3"
            >
              <div class="d-flex align-items-center justify-content-between p-3 bg-light-primary rounded">
                <div>
                  <h6 class="mb-1 text-muted">
                    {{ $t('indicacao.rede.totalUsuarios') }}
                  </h6>
                  <h3 class="mb-0 font-weight-bolder text-primary">
                    {{ estatistica.cadastroAtivo + estatistica.cadastroPendente + estatistica.cadastroVencido }}
                  </h3>
                </div>
                <div class="avatar bg-light-primary p-50">
                  <div class="avatar-content">
                    <feather-icon
                      icon="UsersIcon"
                      size="24"
                    />
                  </div>
                </div>
              </div>
            </b-col>

            <!-- Ativos -->
            <b-col
              cols="12"
              sm="6"
              lg="3"
              class="mb-3"
            >
              <div class="d-flex align-items-center justify-content-between p-3 bg-light-success rounded">
                <div>
                  <h6 class="mb-1 text-muted">
                    {{ $t('indicacao.cardTextAtivos') }}
                  </h6>
                  <h3 class="mb-0 font-weight-bolder text-success">
                    {{ estatistica.cadastroAtivo }}
                  </h3>
                </div>
                <div class="avatar bg-light-success p-50">
                  <div class="avatar-content">
                    <feather-icon
                      icon="CheckCircleIcon"
                      size="24"
                    />
                  </div>
                </div>
              </div>
            </b-col>

            <!-- Pendentes -->
            <b-col
              cols="12"
              sm="6"
              lg="3"
              class="mb-3"
            >
              <div class="d-flex align-items-center justify-content-between p-3 bg-light-warning rounded">
                <div>
                  <h6 class="mb-1 text-muted">
                    {{ $t('indicacao.cardTextPendentes') }}
                  </h6>
                  <h3 class="mb-0 font-weight-bolder text-warning">
                    {{ estatistica.cadastroPendente }}
                  </h3>
                </div>
                <div class="avatar bg-light-warning p-50">
                  <div class="avatar-content">
                    <feather-icon
                      icon="ClockIcon"
                      size="24"
                    />
                  </div>
                </div>
              </div>
            </b-col>

            <!-- Vencidos -->
            <b-col
              cols="12"
              sm="6"
              lg="3"
              class="mb-3"
            >
              <div class="d-flex align-items-center justify-content-between p-3 bg-light-danger rounded">
                <div>
                  <h6 class="mb-1 text-muted">
                    {{ $t('indicacao.cardTextVencidos') }}
                  </h6>
                  <h3 class="mb-0 font-weight-bolder text-danger">
                    {{ estatistica.cadastroVencido }}
                  </h3>
                </div>
                <div class="avatar bg-light-danger p-50">
                  <div class="avatar-content">
                    <feather-icon
                      icon="AlertTriangleIcon"
                      size="24"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-overlay>

    <!-- Seção de Níveis -->
    <b-card
      v-if="estatistica && estatistica.porNivel"
      class="mt-2"
    >
      <h6 class="text-uppercase text-muted mb-2">
        {{ $t('indicacao.rede.detalhesPorNivel') }}
      </h6>
      <b-row class="g-2">
        <b-col
          v-for="(count, nivel) in estatistica.porNivel"
          :key="nivel"
          cols="12"
          sm="6"
          lg="3"
          class="mb-2"
        >
          <div class="p-2 bg-light-info rounded">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <div class="d-flex align-items-center">
                <span class="text-muted font-weight-bold">{{ $t('indicacao.rede.nivel') }} {{ nivel }}</span>
                <b-badge
                  variant="info"
                  class="ml-1"
                >{{ count }} {{ $t('indicacao.rede.usuarios') }}</b-badge>
              </div>
              <div
                class="cursor-pointer"
                @click="toggleNivelDetalhes(nivel)"
              >
                <feather-icon
                  :icon="niveisExpandidos[nivel] ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                  size="16"
                />
              </div>
            </div>
            <b-collapse
              :id="'nivel-' + nivel"
              v-model="niveisExpandidos[nivel]"
            >
              <div
                v-if="getPlanosDoNivel(nivel).length > 0"
                class="border-top pt-2"
              >
                <div
                  v-for="plano in getPlanosDoNivel(nivel)"
                  :key="plano.tipo"
                  class="d-flex justify-content-between align-items-center py-1 small"
                >
                  <span class="text-muted">{{ plano.tipo }}</span>
                  <div class="d-flex align-items-center">
                    <b-badge
                      variant="light-info"
                      class="mr-1"
                    >{{ plano.quantidade }}</b-badge>
                    <small class="text-muted">({{ Math.round(plano.quantidade / count * 100) }}%)</small>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="text-center text-muted small py-1 border-top pt-2"
              >
                <small>Sem planos ativos</small>
              </div>
            </b-collapse>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <!-- Table Section -->
    <b-card
      no-body
      class="mt-2"
    >
      <b-table
        ref="refListTable"
        :items="dataList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('indicacao.emptyTextTable')"
        :sort-desc.sync="isSortDirDesc"
        :busy.sync="loadingOverlay"
        striped
      >
        <template #cell(dataCriacao)="data">
          {{ formatDateBR(data.value) }}
        </template>

        <template #cell(status)="data">
          <b-badge :variant="getStatusColor(data.value)">
            {{ $t(data.value) }}
          </b-badge>
        </template>

        <template #cell(dataInicialPlanoAtual)="data">
          {{ formatDateBR(data.value) }}
        </template>

        <template #cell(dataFimPlanoAtual)="data">
          {{ formatDateBR(data.value) }}
        </template>

        <template #cell(telefone)="data">
          <div class="d-flex align-items-center">
            <b-button
              v-if="data.value"
              variant="success"
              size="sm"
              class="btn-icon mr-1"
              @click="openWhatsApp(data.value)"
            >
              <feather-icon
                icon="MessageSquareIcon"
                size="16"
              />
            </b-button>
            <span>{{ data.value }}</span>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              {{ $t('indicacao.extrato.alertTextMuted', { from: paginationMeta.from, to: paginationMeta.to, of: paginationMeta.of }) }}
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalCount"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTable, BPagination, BRow, BCol, BBadge, BOverlay, BButton, BFormInput, BCollapse, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import store from '@/store'
import utilsMixin from '@/mixins/utilsMixin'
import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import { formatDateBR, formatCurrencyUSD, toIsoStringTimeZone } from '@/utils/filter'
import Ripple from 'vue-ripple-directive'
import redeStoreModule from './redeStoreModule'

const REDE_EXTRATO_STORE_MODULE_NAME = 'indicacao-rede'

export default {

  components: {
    BCard,
    BOverlay,
    BTable,
    BPagination,
    BRow,
    BCol,
    BBadge,
    BFormInput,
    BButton,
    flatPickr,
    BCardHeader,
    BCardBody,
    BCollapse,
  },

  directives: {
    Ripple,
  },

  mixins: [utilsMixin],

  data() {
    return {
      formatCurrencyUSD,
      formatDateBR,
      Portuguese,
      loadingOverlay: false,
      perPage: 15,
      totalCount: 0,
      currentPage: 1,
      sortBy: 'dataCriacao',
      isSortDirDesc: true,
      dataListOriginal: null,
      estatistica: null,
      searchQuery: null,
      niveisExpandidos: {},
      dataBuscaFilter: {
        inicio: null,
        fim: null,
        status: null,
      },
      flatpickrConfig: {
        altInput: true,
        enableTime: false,
        altFormat: 'd/m/Y',
        locale: Portuguese,
      },
    }
  },

  computed: {
    tableColumns() {
      return [
        { key: 'dataCriacao', label: this.$i18n.t('indicacao.rede.dataCadastro') },
        { key: 'nome', label: this.$i18n.t('indicacao.rede.nome') },
        { key: 'email', label: this.$i18n.t('indicacao.rede.email') },
        { key: 'telefone', label: this.$i18n.t('indicacao.rede.telefone') },
        { key: 'nivel', label: this.$i18n.t('indicacao.rede.nivel') },
        { key: 'status', label: this.$i18n.t('indicacao.status') },
        { key: 'planoAtual', label: this.$i18n.t('indicacao.rede.planoAtual') },
        { key: 'dataInicialPlanoAtual', label: this.$i18n.t('indicacao.rede.dataInicioAssinatura') },
        { key: 'dataFimPlanoAtual', label: this.$i18n.t('indicacao.rede.dataFimAssinatura') },
      ]
    },
    paginationMeta() {
      if (!this.dataListOriginal) {
        return {
          from: 0,
          to: 0,
          of: 0,
        }
      }
      const startIndex = (this.currentPage - 1) * this.perPage
      const endIndex = Math.min(startIndex + this.perPage, this.totalCount)
      return {
        from: this.totalCount ? startIndex + 1 : 0,
        to: endIndex,
        of: this.totalCount,
      }
    },
    windowWidth() {
      return this.$store.state.app.windowWidth
    },

    dataList() {
      if (!this.dataListOriginal) return []

      // Se estiver fazendo busca local
      // Calculate the start and end indices based on currentPage and perPage
      const startIndex = (this.currentPage - 1) * this.perPage
      const endIndex = startIndex + this.perPage

      if (this.dataListOriginal) {
        // Slice the original data array to get the items for the current page
        return this.dataListOriginal.slice(startIndex, endIndex)
      }
      return null
    },
  },

  created() {
    if (!store.hasModule(REDE_EXTRATO_STORE_MODULE_NAME)) store.registerModule(REDE_EXTRATO_STORE_MODULE_NAME, redeStoreModule)
    // Inicializa todos os níveis como fechados
    this.niveisExpandidos = Object.keys(this.estatistica?.porNivel || {}).reduce((acc, nivel) => {
      acc[nivel] = false
      return acc
    }, {})
    this.fetchList()
  },

  beforeDestroy() {
    if (store.hasModule(REDE_EXTRATO_STORE_MODULE_NAME)) store.unregisterModule(REDE_EXTRATO_STORE_MODULE_NAME)
  },

  methods: {
    openWhatsApp(phone) {
      // Remove any non-numeric characters from the phone number
      const cleanPhone = phone.replace(/\D/g, '')
      // Open WhatsApp link in new tab
      window.open(`https://wa.me/${cleanPhone}`, '_blank')
    },

    buscarFiltro() {
      this.currentPage = 1
      this.fetchList()
    },

    getStatusColor(value) {
      if (value === 'PENDENTE') return 'warning'
      if (value === 'ATIVO') return 'success'
      if (value === 'VENCIDO') return 'danger'
      return 'warning'
    },

    async fetchList() {
      this.loadingOverlay = true

      // Extrair e formatar data de início
      let dataInicio = this.dataBuscaFilter.inicio
      if (dataInicio) {
        if (typeof dataInicio === 'string' || dataInicio instanceof String) {
          dataInicio = toIsoStringTimeZone(new Date(dataInicio))
        }
      }

      // Extrair e formatar data de fim
      let dataFim = this.dataBuscaFilter.fim
      if (dataFim) {
        if (typeof dataFim === 'string' || dataFim instanceof String) {
          const dataFimTemp = new Date(dataFim)
          dataFimTemp.setDate(dataFimTemp.getDate() + 1)
          dataFim = toIsoStringTimeZone(dataFimTemp)
        } else {
          dataFim.setDate(dataFim.getDate() + 1)
          dataFim = dataFim.toISOString()
        }
      }
      store
        .dispatch('indicacao-rede/getRede', {
          size: this.perPage,
          page: this.currentPage - 1,
          sortBy: this.sortBy,
          sortDesc: this.isSortDirDesc,
          dataInicio,
          dataFim,
          status: this.dataBuscaFilter.status,
          searchQuery: this.searchQuery,
        })
        .then(response => {
          this.dataListOriginal = response.data.cadastros
          this.totalCount = this.dataListOriginal.length
          this.estatistica = response.data.estatistica
        }).finally(() => {
          this.loadingOverlay = false
        })
    },

    getPlanosDoNivel(nivel) {
      if (!this.dataListOriginal) return []
      const usuariosDoNivel = this.dataListOriginal.filter(item => String(item.nivel) === String(nivel) && item.status === 'ATIVO')
      const planosDoNivel = usuariosDoNivel.reduce((acc, item) => {
        if (item.planoAtual && item.planoAtual.trim()) {
          const planoExistente = acc.find(p => p.tipo === item.planoAtual)
          if (planoExistente) {
            planoExistente.quantidade += 1
          } else {
            acc.push({ tipo: item.planoAtual, quantidade: 1 })
          }
        }
        return acc
      }, [])

      return planosDoNivel.sort((a, b) => b.quantidade - a.quantidade)
    },

    toggleNivelDetalhes(nivel) {
      this.$set(this.niveisExpandidos, nivel, !this.niveisExpandidos[nivel])
    },
  },
}
</script>

<style lang="scss">
.hover-lift {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.35) !important;
  }
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';

// Add some hover effects
.btn-icon {
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-2px);
  }
}

.table td {
  vertical-align: middle;
}

// Avatar styles
.avatar {
  &.bg-light-primary,
  &.bg-light-success,
  &.bg-light-warning,
  &.bg-light-danger,
  &.bg-light-info {
    color: inherit;
  }
}
</style>
